import ValidateVatNumber from "./site/components/ValidateVatNumber";

require('./bootstrap');

require('jquery-ui-dist/jquery-ui.min');

require('./site/plugins');
require('./site/functions');

window.Vue = require('vue').default;

require('./backend/UI/flashmessages');

require('sharer.js');

import Vuex from 'vuex';
import {search} from './site/store/search.module';
import {filter} from './site/store/filter.module';
import {favorites} from './site/store/favorites.module';
import {cart} from './site/store/cart.module';
import {label} from './site/store/label.module';


import FullCart from "./site/components/FullCart";
import CartGift from "./site/components/CartGift";
import HeaderCart from "./site/components/HeaderCart";
import OrderConfirmCart from "./site/components/OrderConfirmCart";
import AddToCart from "./site/components/AddToCart";
import AddressAutoComplete from "./site/components/AddressAutoComplete";
// import ProductToCart from "./site/components/ProductToCart";

Vue.component('header-search', require('./site/components/HeaderSearch.vue').default);
Vue.component('newsletter-subscribe', require('./site/components/NewsletterSubscribe.vue').default);
Vue.component('product', require('./site/components/Product.vue').default);
Vue.component('product-list', require('./site/components/ProductList.vue').default);
Vue.component('sidebar-filters', require('./site/components/SidebarFilters.vue').default);
Vue.component('filter-count', require('./site/components/FilterCount.vue').default);
Vue.component('star-rating', require('vue-star-rating').default);
Vue.component('favorite-button', require('./site/components/FavoriteButton.vue').default);
Vue.component('review-list', require('./site/components/ReviewList.vue').default);
Vue.component('review', require('./site/components/Review.vue').default);
Vue.component('contact-form', require('./site/components/ContactForm.vue').default);
Vue.component('campaign-subscribe', require('./site/components/CampaignSubcribe.vue').default);
Vue.component('modal', require('./site/components/Modal.vue').default);
Vue.component('content-popup', require('./site/components/ContentPopup.vue').default);

Vue.component('full-cart', FullCart);
Vue.component('cart-gift', CartGift);
Vue.component('add-to-cart', AddToCart);
Vue.component('header-cart', HeaderCart);
Vue.component('order-confirm-cart', OrderConfirmCart);
Vue.component('address-auto-complete', AddressAutoComplete);
Vue.component('validate-vat-number', ValidateVatNumber);
// Vue.component('product-to-cart', ProductToCart);

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        search,
        filter,
        favorites,
        cart,
        label,
    },
    state: {
        csrfToken: window.axios.defaults.headers.common['X-CSRF-TOKEN']
    },
    actions: {}
});

const app = new Vue({
    el: '#app',
    store,
    methods: {
        formatPrice: (amount, currency, hideZero) => {
            //let currencySign = '€';
            let currencySign = ''; //geen eurotekens
            if (currency === 'GBP') currencySign = '£';
            if (currency === 'USD') currencySign = '$';

            hideZero = !!hideZero;

            if (!amount) {
                amount = 0;
            }

            if (hideZero && amount === 0) {
                return '-';
            } else {
                return currencySign + (parseFloat(amount) / 100).toLocaleString(
                    undefined, // leave undefined to use the browser's locale,
                    // or use a string like 'en-US' to override it.
                    {minimumFractionDigits: 2, maximumFractionDigits: 2}
                );
            }
        },
    },
    mounted() {

        this.$store.commit('label/setFromJsonString', window.labels)

        if (!window.preventCart) {
            this.$store.state.cart_uuid = window.cart_uuid;
            this.$store.state.cart_currency = window.cart_currency;
            this.$store.state.cart_route = window.cart_route;
            this.$store.dispatch('cart/loadCart');
        }

        flash_session();
    }
});

window.trackAddToCartGoogle = function(product, quantity){
    if(window.seo_enabled) {
        window.dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'EUR',
                'add': {
                    'products': [{
                        'name': product.title,
                        'id': product.code,
                        'price': product.price,
                        'brand': product.publisher !== undefined ? product.publisher : '',
                        'category': product.type,
                        'quantity': quantity
                    }]
                }
            }
        });

        window.dataLayer.push({
            'event': 'add_to_cart',
            'value': product.price,
            'items' : [{
                'id': product.code,
                'google_business_vertical': 'retail'
            }]
        });
    }
};

window.trackImpressionsGoogle = function(products){
    if(window.seo_enabled) {
        let impressions = [];
        _.forEach(products, function (product, index) {
            impressions.push({
                'name': product.title,
                'id': product.code,
                'price': product.price.replace(",", "."),
                'brand': product.publisher !== undefined ? product.publisher : '',
                'category': product.type,
                'position': (index + 1)
            });
        });
        window.dataLayer.push({
            'ecommerce': {
                'currencyCode': 'EUR',
                'impressions': impressions
            }
        });
    }
}

window.addEventListener("unhandledrejection", (event) => {
    event.preventDefault();
});
